import React from 'react'
import styles from './Sticker.css'

const Sticker = props =>(
  <div className={`${styles.Sticker} ${props.className}`}>
    {props.children}
  </div>
)

export default Sticker



// WEBPACK FOOTER //
// ./src/components/Sticker/Sticker.js